import { css } from "styled-components";
import { getThemeData, createStyleComponent } from "@hzero-front-ui/core/lib/utils";
var styles = function styles(props) {
  var _getThemeData = getThemeData(props, "badge"),
    _getThemeData$bgColor = _getThemeData.bgColor,
    bgColor = _getThemeData$bgColor === void 0 ? "#F13131" : _getThemeData$bgColor,
    _getThemeData$fontCol = _getThemeData.fontColor,
    fontColor = _getThemeData$fontCol === void 0 ? "#fff" : _getThemeData$fontCol,
    _getThemeData$borderC = _getThemeData.borderColor,
    borderColor = _getThemeData$borderC === void 0 ? "#F13131" : _getThemeData$borderC,
    fontSize = _getThemeData.fontSize,
    height = _getThemeData.height,
    radius = _getThemeData.radius,
    dotSize = _getThemeData.dotSize;
  return css([".ant-badge{&&{.ant-badge-count{background-color:", ";color:", ";border:1px solid ", ";font-size:", "px;height:", "px;line-height:", "px;border-radius:", "px;z-index:5;}.ant-badge-dot{background-color:", ";border:1px solid ", ";width:", "px;height:", "px;}}}"], bgColor, fontColor, borderColor, fontSize, height, height - 2, radius, bgColor, borderColor, dotSize, dotSize);
};
export default createStyleComponent("badge", styles);